// Dependecies
import { useEffect } from 'react';

// store
import locale from '../../store/locale';
import termsAndCondictions from '../../store/termsAndCondictions';

export default function useLoadData(Component) {
  const [localeStore, localeActions] = locale();
  const [termsStore, termsActions] = termsAndCondictions();

  useEffect(() => {
    if (Component) {
      localeActions.setComponentName(Component);
    }

    if (termsStore.itemsTerms.length === 0) {
      termsActions.getTermsAndConditions();
    }
  }, [Component]);

  return { localeStore };
}
